import Phaser from 'phaser';


export default class Score{

    constructor(){
        this.scene =  window.GAME_REF.scene;

        this.container = null;
        this.items = [];

        this._init();
    }


    render(){

        this.scene.tweens.add({
            targets: this.container,
            alpha: 1,
            duration: 300,
            ease: 'Cubic.easeOut'
        });
    }


    update(score){
        const str = score.toString();
        const ary = str.split('').map(Number);

        // すべてのitemsを非表示に設定
        this.items.forEach(item => item.setVisible(false));

        for(let i = 0; i < ary.length; i++){
            this.items[i].setFrame(ary[i]);
            this.items[i].setVisible(true); // 数字があるitemsを表示
        }
    }


    _init(){
        this.container = this.scene.add.container(15, 610);
        this.container.alpha = 0;

        const title = this.scene.add.image(0, 0, 'playing_score');
        title.setOrigin(0, 0);
        this.container.add(title);

        for(let i=0; i<4; i++){
            const num = this.scene.add.sprite(42*i, 40, 'playing_score_number');
            num.setOrigin(0, 0);
            if(i > 0) num.setVisible(false);
            this.container.add(num);
            this.items.push(num);
        }
    }
}